<template>
  <div
    class="statistics__indicator"
    @resize="indicatorResize">
    <div
      class="statistics__indicator-item"
      v-if="value"
      @click.left="jumpUrl">

      <div
        v-if="value.base && !showPropertiesHolder.icon"
        class="indicator-item__base-text">
        <h3>
          {{title}}
        </h3>
        <br>
        <p
          :style="{color: showPropertiesHolder.color ? showPropertiesHolder.color : showPropertiesHolder.customColor}">
          {{value.base.value}}
        </p>
      </div>
      <div
        v-if="value.base && showPropertiesHolder.icon"
        class="indicator-item__base-icon">
        <div class="icon-container">
          <i
            :class="showPropertiesHolder.icon"
            :style="{color: showPropertiesHolder.color ? showPropertiesHolder.color : showPropertiesHolder.customColor}">
          </i>
        </div>
        <div class="info-container">
          <h3
            :style="{color: showPropertiesHolder.color ? showPropertiesHolder.color : showPropertiesHolder.customColor}">
            {{value.base.value}}
          </h3>
          <br>
          <p>{{title}}</p>
        </div>
      </div>
      <div
        v-if="value.upDown"
        class="indicator-item__up-down-text">
        <h3>{{subTitle}}</h3>
        <p>{{value.upDown.value}}</p>
      </div>
    </div>
  </div>
</template>

<script>
  // 指标卡
  import current from "./mixin"
  import {SHORTCUT_BUTTON_TYPE__DATA_DRILLDOWN} from "../../types";

  export default {
    mixins: [current],
    data() {
      return {
      }
    },
    computed: {
      title() {
        return this.showPropertiesHolder.title ? this.showPropertiesHolder.title : (this.value.base ? this.value.base.fieldTitle : '')
      },
      subTitle() {
        return this.showPropertiesHolder.subTitle ? this.showPropertiesHolder.subTitle : (this.value.upDown ? this.value.upDown.fieldTitle : '')
      }
    },
    methods: {
      jumpUrl() {
        const holder = this.showPropertiesHolder
        if (holder.optionType === SHORTCUT_BUTTON_TYPE__DATA_DRILLDOWN) {
          this.showDataDrillDownList(this.value.base)
        }
      },
      indicatorResize() {
      },
      initChart() {}
    },
    watch: {
      // value 发生修改时 重新渲染图表
      value() {
        this.initChart()
      }
    }
  }
</script>

<style rel="stylesheet" lang="less">

  .statistics__indicator {
    width: 100%;
    height: 100%;
    text-align: center;
    position: relative;
    min-height: 100px;

    > .statistics__indicator-item {
      max-width: 100%;
      overflow: hidden;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      text-align: left;

      h3,
      p {
        display: inline-block;
        font-weight: normal;
        line-height: 1.5;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-wrap: break-word;
      }

      .indicator-item__base-text {
        > h3 {
          margin: 0;
          font-size: 18px;
        }

        p {
          margin: 0;
          font-size: 20px;
          font-weight: 400;
        }
      }

      .indicator-item__base-icon {
        display: flex;
        justify-content: center;

        .icon-container {
          padding-top: 15px;
          margin-right: 10px;

          i {
            font-size: 26px;
          }
        }

        .info-container {
          h3 {
            margin: 0;
            font-size: 20px;
            font-weight: 400;
          }

          p {
            margin: 0;
            font-size: 18px;
          }
        }
      }

      .indicator-item__up-down-text {
        > h3 {
          margin: 0;
          font-size: 18px;
          font-weight: 400;
        }

        p {
          margin: 0;
          font-size: 18px;
          color: #ed3f14;
          padding-left: 10px;
        }
      }
    }
  }

</style>
